import React from 'react';
import Iconify from '../../components/Iconify';
import { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';

const PasswordField = ({ value, onChange, error, ...other }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      fullWidth
      size="small"
      type={showPassword ? 'text' : 'password'}
      autoComplete="password"
      value={value}
      onChange={onChange}
      error={error}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword(!showPassword)}
              edge="end"
            >
              <Iconify
                icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'}
              />
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...other}
    />
  );
};

export default PasswordField;
